<script setup lang="ts">
withDefaults(defineProps<{ size?: 's' | 'm'; loading?: boolean }>(), { size: 'm' });

const prefix = 'components.results.filters';
const store = useHoursFilterStore();
const criteriaStore = useSearchCriteriaStore();
</script>

<template>
  <div
    v-if="loading"
    class="flex flex-col gap-4"
  >
    <UiSkeleton class="h-9 w-full rounded-md" />
    <div
      v-for="i in 2"
      :key="i"
      class="flex flex-col gap-2"
    >
      <UiSkeleton class="h-2 w-32 rounded-full" />
      <UiSkeleton class="h-4 w-full rounded-full" />
      <div class="flex justify-between">
        <UiSkeleton class="h-2 w-12" />
        <UiSkeleton class="h-2 w-12" />
      </div>
    </div>
  </div>

  <!-- Beyond two legs the tabs split by bound, not by leg: every departure in the first tab, every arrival in the second. -->
  <ResultsFiltersLegTabsWrapper v-else>
    <template #departure>
      <template v-if="store.committedLegHours.length > 2">
        <ResultsFiltersHoursSlider
          v-for="(leg, index) in store.committedLegHours"
          :key="index"
          v-model="leg.departureValue"
          :size="size"
          :title="$t(`${prefix}.hoursDepartureTitle`)"
          :city-code="criteriaStore.committedLegCityCodes[index]"
          :leg-number="index + 1"
        />
      </template>
      <template v-else-if="store.committedLegHours[0]">
        <ResultsFiltersHoursSlider
          v-model="store.committedLegHours[0].departureValue"
          :size="size"
          :title="$t(`${prefix}.hoursDepartureTitle`)"
          :city-code="criteriaStore.committedLegCityCodes[0]"
        />
        <ResultsFiltersHoursSlider
          v-model="store.committedLegHours[0].arrivalValue"
          :size="size"
          :title="$t(`${prefix}.hoursArrivalTitle`)"
          :city-code="criteriaStore.committedLegArrivalCityCodes[0]"
        />
      </template>
    </template>
    <template #return>
      <template v-if="store.committedLegHours.length > 2">
        <ResultsFiltersHoursSlider
          v-for="(leg, index) in store.committedLegHours"
          :key="index"
          v-model="leg.arrivalValue"
          :size="size"
          :title="$t(`${prefix}.hoursArrivalTitle`)"
          :city-code="criteriaStore.committedLegArrivalCityCodes[index]"
          :leg-number="index + 1"
        />
      </template>
      <template v-else-if="store.committedLegHours[1]">
        <ResultsFiltersHoursSlider
          v-model="store.committedLegHours[1].departureValue"
          :size="size"
          :title="$t(`${prefix}.hoursDepartureTitle`)"
          :city-code="criteriaStore.committedLegCityCodes[1]"
        />
        <ResultsFiltersHoursSlider
          v-model="store.committedLegHours[1].arrivalValue"
          :size="size"
          :title="$t(`${prefix}.hoursArrivalTitle`)"
          :city-code="criteriaStore.committedLegArrivalCityCodes[1]"
        />
      </template>
    </template>
  </ResultsFiltersLegTabsWrapper>
</template>
